import type { SystemUpdateStatus } from './types';

/** Select the durable records for one plugin request without deciding presentation or completion.
 * An omitted request id selects the retained record by plugin name in each source. */
export function pluginUpdateRecords(status: SystemUpdateStatus, name: string, requestId?: string) {
  return {
    queued: status.queue.plugins.find(op => op.name === name && (!requestId || op.requestId === requestId)),
    running: status.journal?.ops.find(op => op.name === name && (!requestId || op.requestId === requestId)),
    outcome: status.report?.plugins.find(op => op.name === name && (!requestId || op.requestId === requestId)),
    preparation: status.report?.operations?.filter(op => op.name === name && (!requestId || op.requestId === requestId))
      .sort((a, b) => b.requestedAt - a.requestedAt)[0],
  };
}
